
import 'normalize.css';
import './sass/main.scss';



import './js/main';
import './js/pagination';
import '/js/searchByQuery.js';
import '/js/lightBoxMovie.js';
import '/js/plugins/switchTime.js';

import './js/header/LogicHeader';
import './js/header/renderHeader';
import './js/header/watchedQueue';
import './js/teamLightbox';
import './js/plugins/btnScroll';

import '@pnotify/core/dist/BrightTheme.css';
import '@pnotify/core/dist/PNotify.css';
// import 'material-icons';